__turbopack_context__.v({
  "chevron": "styles-module-scss-module__d9o5Qa__chevron",
  "container": "styles-module-scss-module__d9o5Qa__container",
  "controls": "styles-module-scss-module__d9o5Qa__controls",
  "icon": "styles-module-scss-module__d9o5Qa__icon",
  "navBtn": "styles-module-scss-module__d9o5Qa__navBtn",
  "prev": "styles-module-scss-module__d9o5Qa__prev",
  "root": "styles-module-scss-module__d9o5Qa__root",
  "slide": "styles-module-scss-module__d9o5Qa__slide",
  "title": "styles-module-scss-module__d9o5Qa__title",
  "title_block": "styles-module-scss-module__d9o5Qa__title_block",
  "viewport": "styles-module-scss-module__d9o5Qa__viewport",
});
